import { useAuthStore } from 'stores/auth-store'
import { db } from 'src/models/db'

class AuthService {
  public async init() {
    const authStore = useAuthStore()
    await authStore.InitAuth()
  }

  public async login(username: string) {
    const returnVal = {
      status: '',
      message: '',
      data: {},
    }
    try {
      const authStore = useAuthStore()
      await authStore.Login(username)
      returnVal.status = 'success'
    } catch (err) {
      if (err instanceof Error) {
        returnVal.status = 'fail'
        returnVal.message = err.message
        returnVal.data = { ...err }
      }
    }
    return returnVal
  }

  // NEW: Fetch users to prepopulate the UI form
  public async getLocalProfiles() {
    try {
      return await db.users.toArray()
    } catch (err) {
      console.error('Failed to load profiles', err)
      return []
    }
  }
  // NEW: Get the last logged-in username for automatic UI filling
  public async getLastActiveUsername(): Promise<string> {
    const authStore = useAuthStore()
    if (authStore.lastActiveUserId) {
      const user = await db.users.get(authStore.lastActiveUserId)
      return user ? user.username : ''
    }
    return ''
  }
} // class AuthService {

export const authService: AuthService = new AuthService()
